module.exports = __webpack_public_path__ + "static/media/widgetImage.5f7721fc.svg";